export const getGuestName = (guest, withPopularName = true) => {
    const popularNamePart = guest.popular_name && withPopularName ? ` (${guest.popular_name})` : '';

    return `${guest.given_name} ${guest.family_name}${popularNamePart}`;
};
